import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DataScopeModel } from 'projects/core/src/lib/models/data-scope.model';

@Component({
  selector: 'app-data-scope-list',
  templateUrl: './data-scope-list.component.html',
  styleUrls: ['./data-scope-list.component.scss']
})
export class DataScopeListComponent extends BaseList implements OnInit {

  public scopes: Array<DataScopeModel> = [];

  protected rightLoad = 'admin.datascope.list';
  protected rightNew = 'admin.datascope.create';
  protected rightOpen = 'admin.datascope.show';
  protected apiUrl = '/data-scopes';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.data_scopes'));
    this.loading = true;
    this.api.getModels('data-scopes').subscribe({
      next: (result: any) => {
        this.scopes = [];
        result.data.forEach((scope: any) => {
          scope = new DataScopeModel().deserialize(scope);
          scope.setTranslocoService(this.transloco);
          this.scopes.push(scope);
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

  getDimensionsLabel(scope: DataScopeModel): string {
    if (!scope.dimensions || scope.dimensions.length === 0) {
      return '';
    }
    return scope.dimensions.map((dimension: string) => {
      let label = dimension;
      if (dimension === 'template') {
        label = this.transloco.translate('common.labels.procedures');
      } else if (dimension === 'businessunit') {
        label = this.transloco.translate('common.labels.businessunits');
      }
      const count = (scope.counts) ? scope.counts[dimension] : null;
      if (count !== undefined && count !== null) {
        return label + ' (' + count + ')';
      }
      return label;
    }).join(', ');
  }

}
